import React from 'react'

class EmployeeFooter extends React.Component {

  constructor () {
    super()
  }

  showTooltip() {
    $('.footer-div .helper-tooltip').removeClass('hidden')
  }

  hideTooltip() {
    $('.footer-div .helper-tooltip').addClass('hidden')
  }

  componentDidMount() {
    this.resizeFooter()
  }

  resizeFooter() {
    const footerText = $('.footer-div .footer-text')
    const footerLink = $('.footer-div .disclaimer-helper')
    footerText.show()
    footerLink.hide()
  }

  render() {
    return (
      <div className='footer-div'>
        <div className='footer-text'>
          <div dangerouslySetInnerHTML={{__html: this.props.disclaimerText}} />
        </div>
        <div className='helper-text disclaimer-helper'>
          <div className='helper-tooltip hidden'>
            <div className='helper-tooltip-text'>
              {this.props.disclaimerText}
            </div>
            <div className='helper-tooltip-pointer'></div>
          </div>
          <div className='helper-icon' onMouseOver={this.showTooltip} onMouseLeave={this.hideTooltip} >
            &lt;  Disclaimer
          </div>
         </div>
      </div>
    );
  }
}

export default EmployeeFooter

// < Disclaimer